import { ProgramNames, PROVIDER_TYPES } from '../../../models'
import { PROGRAM_TAXONOMY, ProgramCustomerPropertyId } from '../../common/constants/customerProgram'
import { TREATMENT_OPTIONS } from '../../common/constants/treatmentOptions'
import { ConsentText, ProgramDisplayLabels } from '../messages'
import { ProgramConfig } from '../types'

export const MEDICATION_MANAGEMENT_PROGRAM = {
  programName: ProgramNames.MedicationManagement,
  blendedCareProgramId: '1b2b8b47-4c0e-49ff-a65c-40e187360b70',
  customerPropertyId: ProgramCustomerPropertyId.blendedCareMeds,

  displayLabels: {
    default: ProgramDisplayLabels.medicationManagement,
    careType: 'Meds',
    clientProfile: 'Meds Management',
    sessionSummary: 'medications management',
  },

  associatedProviderTypes: [PROVIDER_TYPES.LYRAPRESCRIBER.lyraType],
  associatedProviderModalities: ['lyraMedManagement'],

  treatmentOptionProperties: {
    associatedTriageTreatmentOptions: [TREATMENT_OPTIONS.BLENDED_CARE_MEDS],
    programTaxonomyTreatmentOptions: [
      {
        clientele: PROGRAM_TAXONOMY.clientele.individual,
        treatment: PROGRAM_TAXONOMY.treatment.medicationManagement,
        partner: PROGRAM_TAXONOMY.partner.blendedCare,
        offering: PROGRAM_TAXONOMY.offering.default,
      },
    ],
    isFullTreatmentOption: true,
  },

  canRescheduleAppointment: false,
  selfPayEligible: false,

  consents: [
    {
      consentText: ConsentText.medicationManagementConsent,
      consentUrl: 'https://www.lyrahealth.com/bcm-agreement',
      showConsentIf: () => true,
    },
  ],

  questionIdentifiers: {
    SI_QUESTION: 'phq9_9',
    SI_PLAN_QUESTION: 'phq9_9_1',
    SI_INTENT_QUESTION: 'phq9_9_2',
  },

  noteContentMetadataName: {
    INITIAL_NOTE: 'bcmInitialNote',
    SESSION_NOTE: 'bcmSessionNote',
    GENERAL_NOTE: 'bcmGeneralNote',
    REFERRAL_NOTE: 'baseReferralNote',
    OLD_INITIAL_NOTE: 'medsInitialNote',
    OLD_SESSION_NOTE: 'medsSessionNote',
    OLD_GENERAL_NOTE: 'medsGeneralNote',
    OLD_REFERRAL_NOTE: 'medsReferralNote',
  },
} satisfies ProgramConfig
